(() => {
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduceMotion) return;

  document.body.classList.add("doluchi-premium-motion");

  const selectors = [
    ".dl-prod",
    ".dl-cat-card",
    ".dl-subcat-card",
    ".dl-hero-visual",
    ".dl-story-visual",
    ".resource-card",
    ".card",
    ".product-card",
  ].join(",");

  const applyMotion = (element, event) => {
    const rect = element.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    const x = (event.clientX - rect.left) / rect.width;
    const y = (event.clientY - rect.top) / rect.height;
    const strength = element.matches(".dl-prod, .resource-card, .product-card") ? 4.5 : 6.5;
    const tiltX = (0.5 - y) * strength;
    const tiltY = (x - 0.5) * strength;
    const shiftX = (x - 0.5) * 12;
    const shiftY = (y - 0.5) * 12;

    element.style.setProperty("--dl-tilt-x", `${tiltX.toFixed(2)}deg`);
    element.style.setProperty("--dl-tilt-y", `${tiltY.toFixed(2)}deg`);
    element.style.setProperty("--dl-shine-x", `${(x * 100).toFixed(1)}%`);
    element.style.setProperty("--dl-shine-y", `${(y * 100).toFixed(1)}%`);
    element.style.setProperty("--dl-shift-x", `${shiftX.toFixed(2)}px`);
    element.style.setProperty("--dl-shift-y", `${shiftY.toFixed(2)}px`);
  };

  const resetMotion = (element) => {
    element.style.removeProperty("--dl-tilt-x");
    element.style.removeProperty("--dl-tilt-y");
    element.style.removeProperty("--dl-shine-x");
    element.style.removeProperty("--dl-shine-y");
    element.style.removeProperty("--dl-shift-x");
    element.style.removeProperty("--dl-shift-y");
  };

  document.addEventListener(
    "pointermove",
    (event) => {
      if (!(event.target instanceof Element)) return;
      const element = event.target.closest(selectors);
      if (!element) return;
      applyMotion(element, event);
    },
    { passive: true },
  );

  document.addEventListener(
    "pointerleave",
    (event) => {
      if (!(event.target instanceof Element)) return;
      const element = event.target.closest(selectors);
      if (element) resetMotion(element);
    },
    true,
  );
})();
